import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f457140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "share-icon" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { class: "slide" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = { class: "protocol" }
const _hoisted_10 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isApp)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "share",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShare && _ctx.handleShare(...args)))
          }, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('分享')), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideTop, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.rowId
        }, [
          (item.type === 'video')
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: item.image,
                title: "YouTube video player",
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: ""
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: item.image,
                alt: "",
                onClick: ($event: any) => (_ctx.handleClick(item))
              }, null, 8, _hoisted_5))
        ], 64))
      }), 128)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Slide, {
          list: _ctx.configInfo.slide
        }, null, 8, ["list"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideBottom, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.rowId
        }, [
          (item.type === 'video')
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: item.image,
                title: "YouTube video player",
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: ""
              }, null, 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: item.image,
                alt: "",
                onClick: ($event: any) => (_ctx.handleClick(item))
              }, null, 8, _hoisted_8))
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configInfo.protocol, (item) => {
        return (_openBlock(), _createElementBlock("img", {
          src: item.image,
          alt: "",
          key: item.rowId,
          onClick: ($event: any) => (_ctx.handleClick(item))
        }, null, 8, _hoisted_10))
      }), 128))
    ])
  ]))
}